/**
 * Farfalla — Sample Guard
 * Entfernt kostenlose Proben automatisch aus dem Warenkorb, sobald der
 * Warenkorbwert der echten Produkte die jeweilige Schwelle wieder unterschreitet.
 * Konfiguration kommt aus window.FarfallaSampleGuard (in theme.liquid gesetzt).
 */
(function () {
  'use strict';

  var CFG = window.FarfallaSampleGuard || {};
  var T1 = Number(CFG.threshold1) || 7000; // erste kostenlose Probe ab (Cents/Rappen)
  var T2 = Number(CFG.threshold2) || 11000; // weitere Proben ab
  var MAX = Number(CFG.max) || 3;
  var MSG = CFG.message || '';
  var SAMPLE_TYPE = 'Proben';
  var HANDLE_PREFIX = 'probe-';

  var busy = false;

  function isSample(item) {
    return (
      item.product_type === SAMPLE_TYPE ||
      (typeof item.handle === 'string' && item.handle.indexOf(HANDLE_PREFIX) === 0)
    );
  }

  function allowedCount(qualifyingCents) {
    if (qualifyingCents >= T2) return MAX;
    if (qualifyingCents >= T1) return 1;
    return 0;
  }

  function enforce() {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var qualifying = 0;
        var samples = [];

        (cart.items || []).forEach(function (it) {
          if (isSample(it)) {
            samples.push(it);
          } else {
            qualifying += it.final_line_price;
          }
        });

        var sampleQty = samples.reduce(function (n, it) {
          return n + it.quantity;
        }, 0);
        var surplus = sampleQty - allowedCount(qualifying);

        if (surplus <= 0) {
          busy = false;
          return;
        }

        var target = samples[samples.length - 1];
        var removed = removeLine(target.key);

        if (removed && MSG) showNotice(MSG);

        setTimeout(function () {
          busy = false;
        }, 400);

        if (!removed) busy = false;
      })
      .catch(function () {
        busy = false;
      });
  }

  function removeLine(key) {
    var el = document.querySelector('[data-cart-item][data-item="' + cssAttr(key) + '"]');
    if (!el) return false;

    el.dispatchEvent(
      new CustomEvent('theme:cart:update', {
        bubbles: false,
        detail: { id: key, quantity: 0 }
      })
    );
    return true;
  }

  function cssAttr(value) {
    return String(value).replace(/"/g, '\\"');
  }

  var noticeTimer = null;
  function showNotice(text) {
    var id = 'farfalla-sample-guard-notice';
    var n = document.getElementById(id);

    if (!n) {
      n = document.createElement('div');
      n.id = id;
      n.setAttribute('role', 'status');
      n.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
        'z-index:100000;max-width:90vw;padding:11px 18px;border-radius:100px;' +
        'background:rgba(33,33,33,.92);color:#fff;font-size:13px;line-height:1.35;' +
        'text-align:center;box-shadow:0 6px 24px rgba(0,0,0,.18);opacity:0;' +
        'transition:opacity .25s ease;pointer-events:none;';
      document.body.appendChild(n);
    }

    n.textContent = text;
    requestAnimationFrame(function () {
      n.style.opacity = '1';
    });

    if (noticeTimer) clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      n.style.opacity = '0';
    }, 4000);
  }

  document.addEventListener('theme:cart:added', enforce);
})();